import React from 'react';
import { Button, Collapse, Grid, Card, List, ListItemButton, ListItemText, Box, Typography, Tooltip } from '@mui/material';
import IconAdministration from '~/components/IconsSvg/administration';
import { useLang } from '~/hooks/useLang';
import {
  ExpandLess,
  ExpandMore,
  StarBorder,
} from '@mui/icons-material';

import { useHistory } from 'react-router-dom';
import useUserState from '~/features/User/stores/UserState';
import { MenuProps } from '~/components/SidebarMenu/interfaces';

export default function OrganItem({ handleMenuClick }: MenuProps) {
  const { translate } = useLang();
  const { verifyPermission } = useUserState();
  const [openOrganItem, setOpenOrganItem] = React.useState(false);

  const history = useHistory();

  const handleClickOrganItem = () => {
    setOpenOrganItem(!openOrganItem);
  }



  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {verifyPermission([
        'organization_index',
        'action_taken_index'
      ]) && (
          <>
            <Tooltip title={translate('Organs options')} placement="right">
              <ListItemButton sx={{ pl: 4 }} onClick={handleClickOrganItem}>
                <ListItemText primary={translate('Organs')} />
                {openOrganItem ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </Tooltip>
            <Collapse in={openOrganItem} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                {verifyPermission(['organization_index']) && (
                  <Tooltip title={`${translate('Create, read, update and delete')}` + ' ' + `${translate('Organizations')}`} placement="right">
                    <ListItemButton sx={{ pl: 8 }} onClick={() => {
                      handleMenuClick('administration')
                      history.push("/organization")
                    }}>
                      <ListItemText primary={translate('Organizations')} />
                    </ListItemButton>
                  </Tooltip>
                )}

                {verifyPermission(['action_taken_index']) && (
                  <Tooltip title={`${translate('Create, read, update and delete')}` + ' ' + `${translate('Action Taken')}`} placement="right">
                    <ListItemButton sx={{ pl: 8 }} onClick={() => {
                      handleMenuClick('administration')
                      history.push("/action-taken")
                    }}>
                      <ListItemText primary={translate('Action Taken')} />
                    </ListItemButton>
                  </Tooltip>
                )}

              </List>
            </Collapse>
          </>
        )}
    </>
  );
}
